import {
  ListItemAvatar,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Link,
  Avatar,
  Alert,
  Badge,
} from "@mui/material";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";

import constants from "../static/constants.json";
import {
  getEventTextFromTypeId,
  getJobTypeName,
  getUserPhotoSrc,
} from "../utils/utils";
import { EventsAPI } from "../apis/eventsAPI";
import { seeEvents } from "../redux/eventSlice";

type NotificationsDrawerProps = {
  open: boolean;
  onClose: () => void;
};

const NotificationsDrawer = ({ open, onClose }: NotificationsDrawerProps) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state: any) => state.user);
  const events = useSelector((state: any) => state.events.list);

  const [unseenEventIds, setUnseenEventIds] = useState([] as string[]);

  useEffect(() => {
    if (user && user.id) {
      console.log('this user is ', user.id);
      const unseen = events.filter((e: any) => {
        return (
          e.actorId !== user.id &&
          !e.seen &&
          e.typeId !== constants.eventType.created
        );
      });
      console.log('unseen is ', unseen);
      setUnseenEventIds(unseen.map((e: any) => e.id));
    }
  }, [events, user]);

  const markUnseenEventsAsSeen = async () => {
    try {
      await EventsAPI.markAsSeen(unseenEventIds);
      dispatch(seeEvents(unseenEventIds));
      onClose();
    } catch(e) {
      console.log('e marking as seen is ', e);
    }
  }

  const markEventAsSeen = async (eventId: string) => {
    try {
      await EventsAPI.markAsSeen([eventId]);
      dispatch(seeEvents([eventId]));
    } catch(e) {
      console.log('e marking as seen is ', e);
    }
  }

  const getEventsContent = () => {
    if (events.length === 0) {
      return <Alert> No notifications</Alert>;
    } else {
      return (
        <List>
          {events.map((e: any) => {
            if (e.typeId !== constants.eventType.created ){
              return (
                <ListItem>
                  <ListItemAvatar>
                    <Badge
                      badgeContent={unseenEventIds.indexOf(e.id) > -1 ? 1 : 0}
                      color="error"
                    >
                      <Avatar
                        alt={e.actorName}
                        src={getUserPhotoSrc(e.actorId)}
                      />
                    </Badge>
                  </ListItemAvatar>
                  <ListItemButton
                    onClick={() => {
                      onClose();
                      markEventAsSeen(e.id);
                      if (
                        user.personTypeId === constants.personType.propertyManager
                      ) {
                        navigate(`/jobs/${e.jobId}`);
                      } else {
                        navigate(`/assignments/${e.jobId}`);
                      }
                    }}
                  >
                    <ListItemText
                      primary={`${e.actorName} ${getEventTextFromTypeId(
                        e.typeId
                      )}`}
                      secondary={`${getJobTypeName(e.job.typeId)} on ${dayjs(
                        e.job.startTime
                      ).format("MMM D")}`}
                    />
                  </ListItemButton>
                </ListItem>
              );
            } else return null;
            
          })}
          <ListItem>
            <ListItemButton onClick={() => {}}>
              <Link onClick={() => {markUnseenEventsAsSeen()}}> Mark all as seen</Link>
            </ListItemButton>
          </ListItem>
        </List>
      );
    }
  };

  return (
    <Drawer open={open} anchor="right" onClose={() => onClose()}>
      {getEventsContent()}
    </Drawer>
  );
};

export default NotificationsDrawer;
